module.exports = __webpack_public_path__ + "img/home_hero.f38672f6.png";